import ForwardChannelList from 'gcs-agent-web/src/components/ForwardChannelList/ForwardChannelList';
import MessageInputArea from 'gcs-agent-web/src/components/MessageInputArea/MessageInputArea';
import { useGetETSTicketPartsQuery, useGetETSTicketQuery } from 'gcs-common/clients/api/entities/tickets/tickets-api';
import { useIsMobile } from 'gcs-common/design-system/hooks/use-media-query';
import LoadingSpinner from 'gcs-common/design-system/ui/loading-spinner';
import { messageStagedTicketPart } from 'gcs-common/slices/messageInput/messageInputSlice';
import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import TicketMessagePart from '../TicketMessagePart/TicketMessagePart';

const TicketForwardMessage = () => {
  const dispatch = useDispatch();
  const { routeTicketId, type, index } = useParams<{
    routeTicketId: string;
    type: 'alternatives' | 'parts';
    index: string;
  }>();
  const ticketId = routeTicketId ?? '';
  const isMobile = useIsMobile();

  const { data, isPending: isPendingPart } = useGetETSTicketPartsQuery({ path: { ticket_id: ticketId } });
  const { data: ticket, isPending: isPendingTicket } = useGetETSTicketQuery({ path: { ticket_id: ticketId } });

  const isPending = isPendingPart || isPendingTicket;

  const part = useMemo(() => {
    if (!data || !type || index === undefined) return null;
    return data[type]?.[Number(index)];
  }, [data, type, index]);

  useEffect(() => {
    if (!part) return;
    dispatch(
      messageStagedTicketPart({
        text: null,
        ticketPart: {
          id: ticketId,
          amount: part.amount,
          articleNumber: part.articleNumber,
          description: part.description,
          kbn: part.kbn,
          manufacturer: part.manufacturer,
          url: part.url,
          externalJiraKey: ticket?.externalJiraKey,
        },
      }),
    );
  }, [dispatch, ticketId, part, ticket]);

  return (
    <>
      {isPending ? (
        <div className="m-auto">
          <LoadingSpinner />
        </div>
      ) : (
        <div className="flex h-full flex-col justify-between">
          <ForwardChannelList forwardingFromEts />
          {part && !isMobile && (
            <div className="m-auto py-2">
              <TicketMessagePart
                ticketId={ticketId}
                description={part.description}
                manufacturer={part.manufacturer}
                kbn={part.kbn}
                externalJiraKey={ticket?.externalJiraKey}
                amount={part.amount}
                articleNumber={part.articleNumber}
                url={part.url}
                partType={type}
                index={Number(index)}
                className="max-w-full justify-center rounded-2xl"
              />
            </div>
          )}
          <div className="p-0">
            <MessageInputArea forwardingFromEts />
          </div>
        </div>
      )}
    </>
  );
};

export default TicketForwardMessage;
